// components/markers/ItemGroupMarker.jsx
import { useEffect, useMemo } from "react";
import { StackedMarker } from "./StackedMarker";
import { SingleMarker } from "./SingleMarker";
import useCommonMap from "../../../hooks/useCommonMap";

/**
 * Registers a portal into the AdvancedMarker element for this group.
 * Renders nothing itself — all output goes through the portal.
 */
export function ItemGroupMarker({
  groupKey,
  markerEntry,
  registerPortal,
  unregisterPortal,
}) {
  // const {
  //   // registerPortal,
  //   // unregisterPortal,
  //   selectedId,
  //   setSelectedId,
  // } = useMapContext();

  const { selectedId, setSelectedId } = useCommonMap();

  const { marker, element, group } = markerEntry;
  const firstItem = useMemo(() => {
    return group?.items[0];
  }, [group?.items[0]]);

  const content = useMemo(() => {
    return (
      <>
        {group.count > 1 ? (
          <StackedMarker
            group={group}
            isSelected={selectedId === groupKey}
            onSelect={(items) => setSelectedId(groupKey, items)}
          />
        ) : (
          <SingleMarker
            marker={marker}
            item={Object.assign({}, firstItem, { lastPosition: firstItem })}
            isSelected={selectedId === groupKey}
            showInfo={group.showInfo}
            onSelect={() => setSelectedId(groupKey)}
          />
        )}
      </>
    );
  }, [group.count, group, selectedId, firstItem, marker.position]);

  useEffect(() => {
    // Register portal every render — React reconciles the content in place
    registerPortal(groupKey, element, content);

    return () => unregisterPortal(groupKey);
  }, [groupKey, content]);

  // Component renders nothing into the React tree
  return null;
}
